module.exports = __webpack_public_path__ + "img/PD.fd989c1a.png";